import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TranslocoService} from '@jsverse/transloco';

import {environment} from '../../environments/environment';

/**
 * Aggiunge `Accept-Language` (lingua attiva di Transloco) alle richieste verso il backend, così i
 * contenuti localizzati (testo dei termini, messaggi d'errore) arrivano nella lingua dell'utente.
 *
 * Solo verso `environment.servicesUrl` (mai verso asset, dizionari o terze parti) e solo se
 * l'header non è già stato impostato dal chiamante. Con `servicesUrl` vuoto (environment di base)
 * si riconoscono le chiamate relative `/api/`. Per valori come `it`/`en` l'header è
 * CORS-safelisted: non introduce preflight.
 */
@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {
  constructor(private readonly transloco: TranslocoService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const base = environment.servicesUrl;
    const verso = base ? req.url.startsWith(base) : req.url.startsWith('/api/');
    if (!verso || req.headers.has('Accept-Language')) {
      return next.handle(req);
    }
    const lingua = this.transloco.getActiveLang();
    if (!lingua) {
      return next.handle(req);
    }
    return next.handle(req.clone({setHeaders: {'Accept-Language': lingua}}));
  }
}
